module.exports = __webpack_public_path__ + "static/img/i3.a24971d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/i3.png
// module id = ZRQU
// module chunks = 0